import Model from './Model';

export default class Mailform extends Model {
    resource() {
        return 'mailform';
    }


    // update the mailform
    updateMailForm(id, data) {
        return this.request({
            url: `${this.resource()}/${id}`,
            method: 'put',
            data: {
                ...data
            }
        });
    }
}
